import { render, staticRenderFns } from "./federate-hqy-page.vue?vue&type=template&id=d98b7114&"
import script from "./federate-hqy-page.vue?vue&type=script&lang=ts&"
export * from "./federate-hqy-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports